<pop-settings-box labelKey="DATA_MANAGEMENT.SELECT_ESTIMATE">
  <div middle
       class="switches">
    <div class="estimate-switch">
      <span class="label"
            translate="DATA_MANAGEMENT.SHOW_ALL_ESTIMATES"></span>
      <pop-switch [(isSwitched)]="showAllEstimates"
                  (isSwitchedChange)="toggleShowAllEstimates()"></pop-switch>
    </div>

  </div>

  <div class="export-picker-zone">
    <pop-estimate-picker #estimatePicker
                         class="project-import"
                         [(selectedEstimate)]="selectedEstimate"
                         [estimateFilter]="filterEstimates"
                         (selectedEstimateChange)="selectedEstimateChange($event)"
                         styleClass="rem-fix"></pop-estimate-picker>
    <div *ngIf="selectedEstimate"
         class="link">
      <a [routerLink]="getEstimateRoute(selectedEstimate.id)">{{ selectedEstimate.projectCode }}</a>
    </div>
    <div *ngIf="currentError"
         class="export-error">
      <i class="fa-regular fa-triangle-exclamation"></i>
      <span [translate]="currentError"></span>
    </div>
  </div>
</pop-settings-box>


<div class="spacer"></div>

<button class="pop-button export-button"
        [disabled]="!selectedEstimate || !canExportProject"
        translate="DATA_MANAGEMENT.EXPORT_PROJECT"
        (click)="exportProject()">
  <i *ngIf="exportLoading"
     class="fa-solid fa-spinner-third fa-spin"></i>
</button>

<div class="spacer"></div>

<div *ngFor="let result of resultsList">
  <div class="box box-success">
    <div>
      <a [routerLink]="result?.routerLink">{{ result.referenceCode }}</a>
      <span [translate]="result.titleKey"></span>
    </div>
  </div>

  <div class="spacer"></div>
</div>
